export default __webpack_public_path__ + "static/media/avatar_fairy_pixie6.3c96f67b.mp3";